import React from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';
import {
  API_KEY_JOBS,
  API_SUCCESS_MESSAGES,
  GET_BUSINESS_INFO,
} from '../../constants';
import { mapBusinessResponseToBusinessAttributes } from '../../utilities/helpers';
// const mapStateToProps = createStructuredSelector({
//   notification: selectNotifications(),
// });

export default Component => ({ businessId, ...others }) => {
  const [business, setBusiness] = React.useState({});
  const notification = useSelector(state => state.notification);
  console.log('RED', notification);
  const getBusinessInfo = async () => {
    const token = localStorage.getItem('accessToken');
    try {
      const response = await axios({
        method: 'get',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': `${API_KEY_JOBS}`,
          Authorization: `Bearer ${token}`,
        },
        url: `${GET_BUSINESS_INFO}/${businessId}/businesses`,
        validateStatus(status) {
          return status === 200; // default
        },
      });
      if (response.data.businesses.length)
        setBusiness(
          mapBusinessResponseToBusinessAttributes(response.data.businesses[0]),
        );
      return response.data;
    } catch (err) {
      throw err;
    }
  };
  React.useEffect(() => {
    getBusinessInfo();
  }, []);

  React.useEffect(() => {
    if (notification.msg === API_SUCCESS_MESSAGES.BUSINESS_UPDATED)
      getBusinessInfo();
  }, [notification.msg]);

  console.log('businessAttributes', business);
  return <Component businessAttributes={business} {...others} />;
};
